<template>
  <div>客户报价等级</div>
</template>

<script>
export default {

}
</script>

<style lang="sss" scoped>


</style>